import { Component } from 'react';
import styled, { css } from 'styled-components';

import { IconPlay } from '@yj-intl/riff-react';
import { fontSize } from '../../../../common/css/setting/variable';
import { mixinThumbnailLine, mixinThumbnailTimeLabel, pcVisitedLink } from '../../../../common/css/setting/mixin';

interface IProps {
  title: string;
  contentId?: string;
  contentIdType?: string;
  url: string;
  imageUrl: string;
  hasVideo: boolean;
  videoDuration?: string;
  secValue?: string;
  mtestId: string | null;
}

const Wrapper = styled.p`
  width: 232px;
  padding-left: 12px;
  font-size: ${fontSize.px14};
`;

const ImageLink = styled.a`
  display: block;
  ${pcVisitedLink}
`;

const TopicsImage = styled.span<{ $hasVideo: IProps['hasVideo'] }>`
  ${mixinThumbnailLine({ width: '220px', height: '220px' })};
  display: flex;
  align-items: center;
  position: relative;
  width: 220px;
  height: 220px;
  margin-bottom: 8px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  // 動画時背景色変更
  ${({ $hasVideo }) =>
    $hasVideo
      ? css`
          background-color: ${props => props.theme.news.palette.thumbnail_movie_common};
        `
      : css`
          background-color: ${props => props.theme.news.palette.thumbnail_normal_common};
        `}
`;

const VideoTime = styled.span`
  ${mixinThumbnailTimeLabel({})}
  position: absolute;
  right: 0;
  bottom: 0;
`;

const StyledIconPlay = styled(IconPlay)`
  margin-right: 2px;
  color: #fff;
`;

export default class TopicsThumbnail extends Component<IProps> {
  /**
   *
   */
  public render() {
    const videoDuration = this.props.hasVideo ? (
      <VideoTime>
        <StyledIconPlay size={11} />
        {this.props.videoDuration}
      </VideoTime>
    ) : null;

    const sec = this.props.secValue || '';
    const dataClParams = `_cl_vmodule:${sec};_cl_link:img;`;
    // 画像のファイルサイズ削減のため長辺が440px（Retinaを考慮してピックアップ枠の2倍）になるように縮小
    const imageUrlParams = this.props.imageUrl.indexOf('?') === -1 ? '?w=440&h=440&pri=l&up=0' : '';

    return (
      <Wrapper>
        <ImageLink href={this.props.url} data-cl-params={dataClParams}>
          <TopicsImage
            $hasVideo={this.props.hasVideo}
            style={{ backgroundImage: `url(${this.props.imageUrl}${imageUrlParams})` }}
          >
            {videoDuration}
          </TopicsImage>
          {this.props.title}
        </ImageLink>
      </Wrapper>
    );
  }
}
